const KoTicketTable_COLUMNS = [
  {
    name: "epicId",
    id: "epicId",
    label: "Epic Id",
    width:130,
    widget: "ticketLink",
    fixed: true
  },

  {
    name: "summary",
    id: "summary",
    label: "Summary",
    width:230,
    widget: "text"
  },
  {
    name: "status",
    id: "status",
    label: "Status",
    widget: "taskstatus",
    isLog:true,
    width:150
  },
  {
    name: "priority",
    id: "priority",
    label: "Priority",
    widget: "priority",
    width:130
  },
  {
    name: "assignee",
    id: "assignee",
    label: "Assignee",
    widget: "assignees"
  },
  // {
  //   name: "attachments",
  //   id: "attachments",
  //   label: "Attachments",
  //   widget: "attachments"
  // },
  {
    name: "reporter",
    id: "reporter",
    label: "Reporter",
    widget: "assignees"
  }];


export default KoTicketTable_COLUMNS;